export default __webpack_public_path__ + "static/media/close-white.5a902268.svg";